type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
};

export default function SectionHeading({ eyebrow, title, subtitle, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div>
        <span className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#48AEEF]">
          {eyebrow}
        </span>
        <h2 className="mt-2 text-[26px] font-bold leading-tight tracking-tight md:text-[34px]">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 max-w-[620px] text-[15px] leading-relaxed text-[#868E96] md:text-[16px]">
            {subtitle}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
